import { render, staticRenderFns } from "./FoodPublicLabel.vue?vue&type=template&id=7becc09a&scoped=true&"
import script from "./FoodPublicLabel.vue?vue&type=script&lang=js&"
export * from "./FoodPublicLabel.vue?vue&type=script&lang=js&"
import style0 from "./FoodPublicLabel.vue?vue&type=style&index=0&id=7becc09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7becc09a",
  null
  
)

export default component.exports